export function searchByName(name, client) {
  const fullName = `${client?.firstName} ${client?.lastName}`;
  const fullNameLower = fullName.toLowerCase();
  const nameLower = name.toLowerCase();
  return fullNameLower.includes(nameLower);
}
